import { AppRoute } from "shared/types/AppRoute";
import { AuthLogin } from "../components/AuthLogin";

export const authRoutes: AppRoute[] = [
  {
    path: "/auth/login",
    component: AuthLogin,
  },
];
